import { useState } from 'react';
import type { EventClient } from '@aicores/events';
import type { ClosingQuestionConfig } from './types';

interface Props {
  config: ClosingQuestionConfig;
  events: EventClient;
  visible: boolean;
}

export function ClosingQuestion({ config, events, visible }: Props) {
  const [answered, setAnswered] = useState<ClosingQuestionConfig['options'][number]['value'] | null>(
    null,
  );

  if (!visible) return null;

  function choose(value: ClosingQuestionConfig['options'][number]['value']) {
    if (answered) return;
    setAnswered(value);
    events.fire('ome_usage_reported', { answer: value });
  }

  return (
    <section className="closing-question">
      <div className="closing-question-label">One quick question</div>
      <div className="closing-question-title">{config.question}</div>
      {answered ? (
        <div className="closing-thankyou">Thanks — that's genuinely useful.</div>
      ) : (
        <div className="closing-options">
          {config.options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`closing-option${answered === opt.value ? ' is-selected' : ''}`}
              onClick={() => choose(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
